import React from "react"
import { NotFoundBody, NotFoundHeader, NotFoundHeadlineLarge } from '../Typography/Typography'
// import { OuterContainer } from '../Navigation/elements'
// import SocialIcons from '../SocialIcons/SocialIcons'
import { SecondaryButton } from '../Button/Button'
import { Box } from "@mui/material"

const NotFoundContent: React.FC = () => {

    return (
        <Box sx={{
            marginBottom: '40px',
        }}>
            {/* <HeroHeadline xsSize="54px" mdSize='60px'>404</HeroHeadline> */}
            <Box sx={{
                width: '100%',
                textAlign: 'center',
            }}>
                <NotFoundHeadlineLarge>404</NotFoundHeadlineLarge>

                <NotFoundHeader>
                    Opps! Page Not Found.
                </NotFoundHeader>
                <NotFoundBody>
                    We can’t seem to find the page you’re looking for.
                    Please try going back to Home page.
                </NotFoundBody>
            </Box>
            <SecondaryButton href='/' style={{ width: '300px', margin: '0 auto', color: 'white', backgroundColor: '#5956E9', borderColor: '#5956E9' }}>Back To Home Page</SecondaryButton>
        </Box>

    )
}
export default NotFoundContent